import React, { useEffect, useState } from 'react';

import {
  DropdownCheckboxOption,
  DropdownMultiSelect,
  DropdownRadioOption,
  IDropdown,
  useMultiSelectOnChange,
} from '~/components/Dropdown';
import { Retry } from '~/components/Retry';
import { IJiraStatus } from '~/domain/IJiraStatus';
import { SITE_CLIENT } from '~/env';
import { useStatusQuery } from '~/hooks/useStatusQuery/useStatusQuery';

interface IFilterJiraStatus extends Pick<IDropdown, 'sx'> {
  typeName: string;
  value?: string[]
  onChange: (status: string[], statusCategory?: string) => void;
}

export const resolveJiraStatusFilter = (statusCategory: string | undefined, status: string[] | undefined, statusList: IJiraStatus[] | undefined) => {
  if (statusCategory === 'all-active') {
    return statusList?.filter(x => x.statusCategory.key !== 'done').map(x => x.untranslatedName) || [];
  } else if (statusCategory === 'all-complete') {
    return statusList?.filter(x => x.statusCategory.key === 'done').map(x => x.untranslatedName) || [];
  }
  return status || [];
}

const initialValue = ['all-active'];
export const FilterJiraStatus: React.FC<IFilterJiraStatus> = (props) => {
  const { typeName, sx, value, onChange } = props;
  const [currentValue, setCurrentValue] = useState(value || initialValue);
  const handleStatusChange = useMultiSelectOnChange({
    currentMode: currentValue[0]?.startsWith('all-') ? 'radio' : 'checkbox',
    onChange: setCurrentValue,
  });

  const {
    data,
    isSuccess,
    isFetching,
    isError,
    refetch,
  } = useStatusQuery({ typeName });

  useEffect(() => {
    setCurrentValue(value || initialValue);
  }, [value]);

  useEffect(() => {
    if (isSuccess) {
      const status = resolveJiraStatusFilter(currentValue[0], currentValue, data);
      const statusCategory = ['all-active', 'all-complete'].includes(currentValue[0]) ? currentValue[0] : undefined;
      onChange(status, statusCategory);
    }
  }, [data, isSuccess, onChange, currentValue]);
  
  return (
    <>
      {(SITE_CLIENT!=='Subaru') && 
      <DropdownMultiSelect
        valueLabel="Status:"
        sx={[{ width: '261px' }, ...(Array.isArray(sx) ? sx : [sx])]}
        isLoading={isFetching}
        value={currentValue}
        onChange={handleStatusChange}
      >
        <DropdownRadioOption value="all-active" sx={{ display: isError ? 'none' : undefined }}>
          All Active
        </DropdownRadioOption>
        {data?.filter(x => x.statusCategory.key !== 'done')?.map(status => {
          const { id, name, untranslatedName } = status;
          return (
            <DropdownCheckboxOption key={id} value={untranslatedName} sx={{ display: isError ? 'none' : undefined }}>
              {name}
            </DropdownCheckboxOption>
          )
        })}
        <DropdownRadioOption value="all-complete" sx={{ display: isError ? 'none' : undefined, mt: '20px' }}>
          Closed Only
        </DropdownRadioOption>
        {data?.filter(x => x.statusCategory.key === 'done')?.map(status => {
          const { id, name, untranslatedName } = status;
          return (
            <DropdownCheckboxOption key={id} value={untranslatedName} sx={{ display: isError ? 'none' : undefined }}>
              {name}
            </DropdownCheckboxOption>
          )
        })}
        {isError && <Retry retry={refetch} sx={{ p: '30px' }} variant="h5">the status</Retry>}
      </DropdownMultiSelect>
      }
      {(SITE_CLIENT==='Subaru') && 
      <DropdownMultiSelect
        valueLabel="Status:"
        sx={[{ width: '261px' }, ...(Array.isArray(sx) ? sx : [sx])]}
        isLoading={isFetching}
        value={currentValue}
        onChange={handleStatusChange}
      >
        <DropdownRadioOption value="all-active" sx={{ display: isError ? 'none' : undefined }}>
          All Active
        </DropdownRadioOption>
      </DropdownMultiSelect>
      }
    </>
  );
}
